import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { searchQueryKeys } from './searchQueryKeys.js';
import { useWoody } from '../../woody/woody.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryRecentSearch = (queryOptions) => {
  const { client } = useWoody();
  const { data: user } = useQueryUserInfo();
  const queryKey = searchQueryKeys.recentSearch();
  const enabled = isQueryEnabled([
    queryOptions?.enabled,
    !!user
  ]);
  const query = useQuery({
    queryKey,
    queryFn: async () => (await client.v2("/v2/search/history", {
      query: {
        limit: 30
      }
    })).searches,
    placeholderData: keepPreviousData,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    refetchInterval: 1e3 * 60,
    staleTime: 60,
    ...queryOptions,
    enabled
  });
  return query;
};

export { useQueryRecentSearch };
//# sourceMappingURL=useQueryRecentSearch.js.map
